/**
 * Interprets validation errors from API response
 * @param {Object} validationError - Error object from API
 * @returns {Object} Object with error messages and metadata
 */
export const interpretValidationErrors = (validationError) => {
  const errors = []
  let isProductNotFound = false
  let requiresModal = false
  
  if (!validationError.errors || validationError.errors.length === 0) {
    return { errors, isProductNotFound, requiresModal }
  }
  
  // Process each error in the errors array
  validationError.errors.forEach(errorObj => {
    switch (errorObj.code) {
      case 'PRODUCT_NOT_CONFIGURED_FOR_INVOICE':
      case 'PRODUCT_INVOICING_NOT_CONFIGURED':
        errors.push(`Produto não configurado para faturamento`)
        isProductNotFound = true
        // Este erro deve ser mostrado na tabela, não no modal
        break
      case 'PRODUCT_CODE_NOT_FOUND':
      case 'PRODUCT_NOT_FOUND':
        errors.push(`Produto não encontrado no sistema`)
        isProductNotFound = true
        requiresModal = true // Este erro deve ser mostrado no modal
        break
      default:
        errors.push(`Erro desconhecido: ${errorObj.code}`)
        break
    }
  })
  
  return { errors, isProductNotFound, requiresModal }
}

/**
 * Processes API validation errors and categorizes them for different display modes
 * @param {Array} validationErrors - Array of validation errors from API
 * @returns {Object} Object with categorized errors
 */
export const processApiValidationErrors = (validationErrors) => {
  const modalErrors = []
  const tableErrors = []
  
  validationErrors.forEach(error => {
    const validationResult = interpretValidationErrors(error)
    
    if (validationResult.requiresModal) {
      modalErrors.push({
        sku: error.sku,
        errors: validationResult.errors,
        isProductNotFound: validationResult.isProductNotFound
      })
    } else {
      tableErrors.push({
        sku: error.sku,
        errors: validationResult.errors,
        isProductNotFound: validationResult.isProductNotFound
      })
    }
  })
  
  return { modalErrors, tableErrors }
}

/**
 * Formats modal errors for display in CsvErrorModal
 * @param {Array} modalErrors - Array of modal errors
 * @returns {string} Formatted error message for modal
 */
export const formatModalErrors = (modalErrors) => {
  if (modalErrors.length === 0) return ''
  const skuCount = modalErrors.length
  
  return `❌ Produtos não encontrados no sistema\n\n` +
         `🔍 ${skuCount} SKU${skuCount > 1 ? 's' : ''} não ${skuCount > 1 ? 'foram encontrados' : 'foi encontrado'} no sistema:\n\n` +
         `${modalErrors.map(error => `• ${error.sku}`).join('\n')}\n\n` +
         `⚠️ Estes produtos não podem ser processados pois não existem no sistema.\n\n` +
         `💡: Este produto não foi encontrado nos sistemas da Cubbo. Verifique se a Natura enviou este produto via integração com o SAP. Caso tenha enviado, compartilhe a evidência da criação do produto no SAP no chat de suporte da Cubbo.`
}